import React, { useEffect } from 'react';
import TagManager from 'react-gtm-module';
import { useLocation, useNavigate } from 'react-router-dom';
// import { CustomButton } from '../../Button/CustomButton';

export function OfferExpired() {
  const navigate = useNavigate();
  const {
    state,
  }: {
    state: {
      location: string;
    };
  } = useLocation();

  useEffect(() => {
    if (
      !state ||
      !state.location ||
      state.location !== '/onecardweb'
    ) {
      navigate('/onecardweb');
    }
  }, []);
  // const notifyEventHandle = () => {};

  TagManager.initialize({
    gtmId: `GTM-${process.env.REACT_APP_GTMID}`,
    auth: process.env.REACT_APP_GTMAUTH,
    preview: process.env.REACT_APP_GTMENV,
    dataLayer: {
      page: 'offerExpired',
    },
    dataLayerName: 'OfferStatusDataLayer',
  });

  return (
    <>
      <div className="h-auto  pb-5 mt-24  flex flex-wrap md:flex-nowrap justify-center  md:justify-start  font-Manrope md:pl-20  w-full 2xl:mt-44   ">
        <div className="w-full  md:w-4/5 h-auto flex items-center flex-wrap md:justify-start  ">
          <div className="md:w-auto w-full  flex flex-col items-center md:items-start md:pb-5 pb-0   ">
            <div className="w-full flex flex-col px-5 sm:px-0   ">
              <h1 className="md:text-3xl text-center md:text-left   text-2xl font-semibold 2xl:text-4xl ">
                Offer Expired
              </h1>
              <div className=" text-center md:text-left  md:w-full 2xl:text-xl">
                <p className=" mt-3 sm:mt-1 2xl:mt-5 ">
                  Your OneCard offer has expired. Currently we’re
                  moderating new card activations.
                </p>
              </div>
              <div className="flex flex-col  text-center sm:text-left mt-5 items-center md:items-start 2xl:text-xl ">
                <p className="mb-5">
                  We’ll send you a notification once this process is
                  active again. Stay tuned.
                </p>
                {/* <CustomButton
                  btntext="Notify"
                  clickEvent={notifyEventHandle}
                  isbuttonactive
                /> */}
              </div>
            </div>
          </div>
        </div>
        <div
          className=" flex  md:w-auto  justify-center mt-10 
          "
        >
          <div className=" h-auto  ">
            <div className="relative h-48 w-72">
              <img
                src="https://www.getonecard.app/assets/apply/metal_card.png"
                alt="onecardMetal"
                className=" absolute h-full w-full"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
